import { getDatafanToken } from "./datafan_token";
export const getDatafanHeaders = () => {
    const datafanToken = getDatafanToken();
    return [
        ["authorization", `JWT ${datafanToken}`],
        // Datafan API requires to provide explicit data format
        ["accept", "application/json"],
    ];
};
//# sourceMappingURL=datafan_headers.js.map